export enum GrnStatusEnum {
    PASS = 'PASS',
    PASSWITHCONDITION = 'PASS WITH CONDITION',
    FAIL = 'FAIL',
}